// Discreet session meter: LLM calls + token tally + graphics spend, fixed
// top-left on every screen. Subscribes to the client's tally (updated on every
// chatComplete, including the Setup ping) and gfx spend — no polling.
import { useSyncExternalStore } from 'react';
import { getTally, subscribeTally } from '../llm/client.js';
import { getGfxSpendUsd, subscribeGfxSpend } from './gfxSpend.js';

function fmtTokens(n: number): string {
  return n >= 1000 ? `${(n / 1000).toFixed(1)}k` : String(n);
}

export default function LlmMeter(): JSX.Element {
  const t = useSyncExternalStore(subscribeTally, getTally);
  const gfxSpend = useSyncExternalStore(subscribeGfxSpend, getGfxSpendUsd);
  const total = t.promptTokens + t.completionTokens;
  return (
    <div
      className="llm-meter"
      title={`Session usage: ${t.calls} LLM call${t.calls === 1 ? '' : 's'} · ${fmtTokens(t.promptTokens)} prompt + ${fmtTokens(t.completionTokens)} completion tokens · $${gfxSpend.toFixed(2)} graphics spend (USD)`}
    >
      {t.calls} call{t.calls === 1 ? '' : 's'} · {fmtTokens(total)} tok · ${gfxSpend.toFixed(2)}
    </div>
  );
}
